import { TaskLogsListItemResponse } from 'app/console-api/tasks/tasks-logs';
import { StyledCardRow } from 'app/components/common/common-styles';
import { BodyText, FlexColumn, formatDate, TableData } from '@make-software/cspr-design';
import React from 'react';

export const TasksLogsItem = ({ data }: { data: TaskLogsListItemResponse }) => {
  return (
    <StyledCardRow key={data.logData.id}>
      <TableData>
        <FlexColumn>
          <BodyText size={3} monotype>
            {formatDate(data.logData.timestamp.toLocaleString())}
          </BodyText>
        </FlexColumn>
      </TableData>
      <TableData>
        <FlexColumn>
          <BodyText size={2} monotype>
            {data.logData.action}
          </BodyText>
          <BodyText size={3} monotype variation={'darkGray'}>
            {data.logData.description}
          </BodyText>
        </FlexColumn>
      </TableData>
      <TableData>
        <FlexColumn>
          <BodyText size={3} monotype>
            {data.userEmail}
          </BodyText>
        </FlexColumn>
      </TableData>
    </StyledCardRow>
  );
};
